/**
 * session
 */
export const STUDENT_SESSION_TTL = 365 * 24 * 60 * 60; // 1 year in seconds

/**
 * slide
 * */
export const SLIDE_PREVIEW_SIZE = {
    width: 340,
    height: 255,
};

export const CANVAS_SIZE = {
    width: 1024,
    height: 768,
};

export const PDF_SIZE = {
    width: 1123,
    height: 794,
};

export const CARD_SIZE_VERTICAL = {
    width: 312,
    height: 468,
};

export const CARD_SIZE_HORIZONTAL = {
    width: 468,
    height: 312,
};

export const IMAGE_COMPRESS_MAX_SIZE = {
    width: 2560,
    height: 1440,
};
export const IMAGE_COMPRESS_QUALITY = 100;

/**
 * result
 */

export const RESULT_DISPLAY_SIZE = {
    width: 200,
    height: 200,
};
export const RESULT_LEGACY_CONTENT_SIZE = {
    width: 640,
    height: 480,
};

export const RESULT_WRITING_V2_SIZE = {
    width: 400,
    height: 400,
};

/**
 * lessons
 */
export const DEFAULT_LESSONS_PAGE_SIZE = 24;

/**
 * trial
 */
export const EVALUATION = {
    MAX_STUDENTS: 3,
};

/**
 * misc
 */
export const FONT_FAMILIES = [
    { fontFamily: 'FZHKXinBiaoKai', name: '方正港版新標楷' },
    { fontFamily: 'FZKai-Z03S', name: '方正楷体简体' },
    { fontFamily: 'Inter', name: 'Inter' },
    { fontFamily: 'Lexend-Regular', name: 'Lexend-Regular' },
    { fontFamily: 'Noto Sans SC', name: 'Noto Sans SC' },
    { fontFamily: 'Noto Sans HK', name: 'Noto Sans HK' },
    { fontFamily: 'Noto Serif SC', name: 'Noto Serif SC' },
    { fontFamily: 'Noto Serif HK', name: 'Noto Serif HK' },
];
export const DEFAULT_FONT_FAMILY = 'Noto Sans SC';

export const Z_INDEX_UI = 99999;

export const AI_VOICE_MAPPING: Record<string, { voiceName: string; role?: string; style?: string; rate?: string; pitch?: string }> = {
    girl: { voiceName: 'zh-CN-XiaoyouNeural', style: 'Default' },
    boy: { voiceName: 'zh-CN-YunxiaNeural', style: 'Default', rate: '-30%' },
    female: { voiceName: 'zh-CN-XiaozhenNeural', style: 'Default', rate: '-15%' },
    male: { voiceName: 'zh-CN-YunfengNeural', style: 'Default', rate: '-15%' },
    seniorFemale: { voiceName: 'zh-CN-XiaomoNeural', role: 'Senior Female', style: 'Default', rate: '-20%', pitch: '-10%' },
    seniorMale: { voiceName: 'zh-CN-YunzeNeural', role: 'Senior Male', style: 'Default', rate: '-20%', pitch: '-5%' },
};

export const NO_BREAK_SPACE = '\u00A0';
